<template>
  <VDialog content-class="dialog" v-bind="$attrs" v-on="$listeners">
    <template v-slot:activator="{on, attrs}">
      <slot name="activator" v-bind="{on, attrs}" />
    </template>
    <div class="relative">
      <VBtn
        v-if="!hideCloseButton"
        icon
        small
        absolute
        top
        right
        @click="close"
        class="btn-close"
      >
        <Close />
      </VBtn>
    </div>
    <slot />
  </VDialog>
</template>

<script>
import Close from '@/components/SvgIcons/Close';

export default {
  name: 'AppDialog',
  components: { Close },
  props: {
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-close {
    z-index: 2;
    top: 50%;
    transform: translate(0, 25%);
    right: 0.625rem;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .btn-close {
      right: 0.5rem;
    }
  }
</style>
